import MaterialGroupsView from './MaterialGroupsView';

const views = {
  MaterialGroupsView,
};
export default views;
